import type { CompoundEntityRef, Entity } from '@backstage/catalog-model';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useCallback } from 'react';
import { useCacheCallback } from './useCacheCallback';
import { createCompoundEntityRef } from '@internal/backstage-plugin-api-catalog-common';

export type GetEntityByRefCallback = (
  entityRef: CompoundEntityRef | string | null | undefined,
  options?: {
    fallbackKind?: string;
  },
) => Promise<Entity | null | undefined>;

export const useGetEntityByRefCallback = (): GetEntityByRefCallback => {
  const catalogApi = useApi(catalogApiRef);
  const requestCallback = useCallback(
    async (
      entityRef: CompoundEntityRef | string | null | undefined,
      options?: {
        fallbackKind?: string;
      },
    ) => {
      const ref = createCompoundEntityRef(entityRef, options?.fallbackKind);
      if (!ref) return null;
      return await catalogApi.getEntityByRef(ref);
    },
    [catalogApi],
  );
  return useCacheCallback(
    requestCallback,
    {
      getCacheKey: (entityRef, options) => {
        const ref = createCompoundEntityRef(entityRef, options?.fallbackKind);
        if (!ref) {
          return 'entityRef:null';
        }
        return `useGetEntityByRefCallback:${stringifyEntityRef(ref)}`;
      },
    },
    [requestCallback],
  );
};
